import { render, staticRenderFns } from "./Propriedades.vue?vue&type=template&id=0065a3b7&scoped=true"
import script from "./Propriedades.vue?vue&type=script&lang=js"
export * from "./Propriedades.vue?vue&type=script&lang=js"
import style0 from "./Propriedades.vue?vue&type=style&index=0&id=0065a3b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0065a3b7",
  null
  
)

export default component.exports